import { render, staticRenderFns } from "./BaseTableView.vue?vue&type=template&id=3188d94a&"
import script from "./BaseTableView.vue?vue&type=script&lang=js&"
export * from "./BaseTableView.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableView.vue?vue&type=style&index=0&id=3188d94a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports